import { render } from "./TableManager.vue?vue&type=template&id=a9cfaad2&ts=true"
import script from "./TableManager.vue?vue&type=script&lang=ts"
export * from "./TableManager.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__